import { useEffect, useState } from "react";

export default function usePrintOrientation(initialOrientation) {
    const [orientation, setOrientation] = useState(initialOrientation);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `@media print { @page {size: ${orientation}} }`;
        style.id = 'page-orientation';
        document.head.appendChild(style);

        return () => {
            const child = document.getElementById('page-orientation');
            child.parentNode.removeChild(child);
        };
    }, [orientation]);

    return [orientation, setOrientation];
}